import React from "react";

function Carousel() {
  
  const slide_img = [
    {
      imgSrc: "assets/images/image-1.png",
      client_name: "Red Cross",
    },
    {
      imgSrc: "assets/images/image-2.jpg",
      client_name: "Gastrocare",
    },
    {
      imgSrc: "assets/images/image-12.png",
      client_name: "Anant Heart ",
    },
    {
      imgSrc: "assets/images/image-3.png",
      client_name: "BMHRC",
    },
    {
      imgSrc: "assets/images/image-4.png",
      client_name: "Jai Prakash",
    },
    {
      imgSrc: "assets/images/image-5.png",
      client_name: "Hamidia",
    },
    {
      imgSrc: "assets/images/image-6.png",
      client_name: "Bhopal Care",
    },
    {
      imgSrc: "assets/images/image-8.jpeg",
      client_name: "JainamShree",
    },
    {
      imgSrc: "assets/images/image-7.jpg",
      client_name: "Gastrocare",
    },
    {
      imgSrc: "assets/images/image-9.jpg",
      client_name: "MPM",
    },
    {
      imgSrc: "assets/images/image-10.png",
      client_name: "Zindal",
    },
  ];

  return (

    <div class="owl-carousel owl-theme">
      {slide_img.map((slides_img, index) => (
        <div class="item owl-slide" key={index}>
          <img
            style={{ aspectRatio: "1/1", mixBlendMode: "multiply" }}
            src={slides_img.imgSrc}
            alt="First slide"
          />

          <div className="owl-slide-text display-7">
            <p style={{ margin: "0px" }}>{slides_img.client_name} </p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Carousel;
